import type { Template } from "@/types";

export const LA_07_H7_V0: Template[] = [
    {
        id: "la-07-h7v0-01",
        name: "LA 01 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_01.png",
        size: [1352, 541],
        style: {},
        slots: [         
            { id: "1", x: 78, y: 86, width: 256, height: 181, rotation: 0, imageRotation: 0 },
            { id: "2", x: 78, y: 275, width: 256, height: 181, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 86, width: 256, height: 181, rotation: 0, imageRotation: 0 },
            { id: "4", x: 342, y: 275, width: 256, height: 181, rotation: 0, imageRotation: 0 },
            { id: "5", x: 793, y: 52, width: 217, height: 142, rotation: 0, imageRotation: 0 },
            { id: "6", x: 793, y: 202, width: 441, height: 290, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1018, y: 52, width: 217, height: 142, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h7v0-02",
        name: "LA 02 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_02.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 39, y: 58, width: 600, height: 426, rotation: 0, imageRotation: 0 },
            { id: "2", x: 801, y: 58, width: 209, height: 137, rotation: 0, imageRotation: 0 },
            { id: "3", x: 801, y: 203, width: 209, height: 137, rotation: 0, imageRotation: 0 },
            { id: "4", x: 801, y: 348, width: 209, height: 136, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1018, y: 58, width: 209, height: 137, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 203, width: 209, height: 137, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1018, y: 348, width: 209, height: 136, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h7v0-03",
        name: "LA 03 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_03.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 93, y: 54, width: 487, height: 307, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 93, y: 369, width: 157, height: 120, rotation: 0, imageRotation: 0 },
            { id: "3", x: 258, y: 369, width: 157, height: 120, rotation: 0, imageRotation: 0 },
            { id: "4", x: 423, y: 369, width: 157, height: 120, rotation: 0, imageRotation: 0 },
            { id: "5", x: 774, y: 54, width: 486, height: 269, rotation: 0, imageRotation: 0 },
            { id: "6", x: 774, y: 331, width: 239, height: 158, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1021, y: 331, width: 239, height: 158, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h7v0-04",
        name: "LA 04 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_04.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 56, y: 71, width: 565, height: 400, rotation: 0, imageRotation: 0 },
            { id: "2", x: 732, y: 71, width: 184, height: 128, rotation: 0, imageRotation: 0 },
            { id: "3", x: 732, y: 207, width: 184, height: 128, rotation: 0, imageRotation: 0 },
            { id: "4", x: 732, y: 343, width: 184, height: 128, rotation: 0, imageRotation: 0 },
            { id: "5", x: 924, y: 71, width: 183, height: 128, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1115, y: 71, width: 183, height: 128, rotation: 0, imageRotation: 0 },
            { id: "7", x: 924, y: 207, width: 374, height: 264, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h7v0-05",
        name: "LA 05 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_05.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 244, y: 55, width: 283, height: 212, rotation: 0, imageRotation: 0 },
            { id: "2", x: 535, y: 55, width: 283, height: 212, rotation: 0, imageRotation: 0 },
            { id: "3", x: 826, y: 55, width: 282, height: 212, rotation: 0, imageRotation: 0 },
            { id: "4", x: 100, y: 274, width: 282, height: 212, rotation: 0, imageRotation: 0 },
            { id: "5", x: 390, y: 274, width: 282, height: 212, rotation: 0, imageRotation: 0 },
            { id: "6", x: 680, y: 274, width: 282, height: 212, rotation: 0, imageRotation: 0 },
            { id: "7", x: 970, y: 274, width: 281, height: 212, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h7v0-06",
        name: "LA 06 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_06.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 108, y: 39, width: 278, height: 195, rotation: 0, imageRotation: 0 },
            { id: "2", x: 394, y: 39, width: 278, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 680, y: 39, width: 278, height: 195, rotation: 0, imageRotation: 0 },
            { id: "4", x: 966, y: 39, width: 277, height: 195, rotation: 0, imageRotation: 0 },
            { id: "5", x: 108, y: 242, width: 373, height: 261, rotation: 0, imageRotation: 0 },
            { id: "6", x: 489, y: 242, width: 373, height: 261, rotation: 0, imageRotation: 0 },
            { id: "7", x: 870, y: 242, width: 373, height: 261, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h7v0-07",
        name: "LA 07 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_07.png",
        size: [1352, 541],
        style: {},
        slots: [         
            { id: "1", x: 50, y: 45, width: 203, height: 145, rotation: 0, imageRotation: 0 },
            { id: "2", x: 50, y: 198, width: 203, height: 145, rotation: 0, imageRotation: 0 },
            { id: "3", x: 50, y: 351, width: 203, height: 144, rotation: 0, imageRotation: 0 },
            { id: "4", x: 261, y: 351, width: 202, height: 144, rotation: 0, imageRotation: 0 },
            { id: "5", x: 471, y: 351, width: 202, height: 144, rotation: 0, imageRotation: 0 },
            { id: "6", x: 261, y: 45, width: 412, height: 298, rotation: 0, imageRotation: 0 },
            { id: "7", x: 681, y: 45, width: 622, height: 450, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h7v0-08",
        name: "LA 08 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_08.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 49, y: 45, width: 622, height: 450, rotation: 0, imageRotation: 0 },
            { id: "2", x: 679, y: 45, width: 203, height: 145, rotation: 0, imageRotation: 0 },
            { id: "3", x: 679, y: 198, width: 203, height: 145, rotation: 0, imageRotation: 0 },
            { id: "4", x: 679, y: 351, width: 203, height: 144, rotation: 0, imageRotation: 0 },
            { id: "5", x: 890, y: 351, width: 202, height: 144, rotation: 0, imageRotation: 0 },          
            { id: "6", x: 890, y: 45, width: 412, height: 298, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1100, y: 351, width: 202, height: 144, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h7v0-09",
        name: "LA 09 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_09.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 71, y: 77, width: 354, height: 256, rotation: 0, imageRotation: 0 },
            { id: "2", x: 433, y: 77, width: 173, height: 124, rotation: 0, imageRotation: 0 },
            { id: "3", x: 433, y: 209, width: 173, height: 124, rotation: 0, imageRotation: 0 },
            { id: "4", x: 71, y: 341, width: 173, height: 123, rotation: 0, imageRotation: 0 },
            { id: "5", x: 252, y: 341, width: 173, height: 123, rotation: 0, imageRotation: 0 },       
            { id: "6", x: 433, y: 341, width: 173, height: 123, rotation: 0, imageRotation: 0 },        
            { id: "7", x: 676, y: 0, width: 676, height: 541, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "la-07-h7v0-10",
        name: "LA 10 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_10.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 676, height: 541, rotation: 0, imageRotation: 0 },
            { id: "2", x: 747, y: 77, width: 354, height: 256, rotation: 0, imageRotation: 0 },          
            { id: "3", x: 1109, y: 77, width: 173, height: 124, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1109, y: 209, width: 173, height: 124, rotation: 0, imageRotation: 0 },
            { id: "5", x: 747, y: 341, width: 173, height: 123, rotation: 0, imageRotation: 0 },        
            { id: "6", x: 928, y: 341, width: 173, height: 123, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1109, y: 341, width: 173, height: 123, rotation: 0, imageRotation: 0 }
        
        ],
    }
];